import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import './frontend.css';

// const useMediaQuery = (query) => {
//   const [matches, setMatches] = useState(window.matchMedia(query).matches);
//   useEffect(() => {
//     const mediaQueryList = window.matchMedia(query);
//     const listener = event => setMatches(event.matches);
//     mediaQueryList.addListener(listener);
//     return () => mediaQueryList.removeListener(listener);
//   }, [query]);
//   return matches;
// };

const Section = ({
  sectionNumber,
  apiUrl,
  showBorder,
  borderColor,
  image1Width,
  image2Width,
  imageAlign,
  layoutType,
  textContent,
  category_code
}) => {
  const [blockData, setBlockData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // const isMobile = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}category/${encodeURIComponent(category_code)}/children?c=33213213`
        );
        const { category } = response.data.data;
        setBlockData(category.block_data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setError('Error fetching data');
        setLoading(false);
      }
    };

    fetchData();
  }, [sectionNumber, apiUrl]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  const renderBlockContent = (block) => {
    const imgStyles = { width: `${image1Width}px`, float: imageAlign };
    const imgStyles2 = { width: `${image2Width}px`, float: imageAlign };
    const containerStyles = {
      border: showBorder ? `1px solid ${borderColor}` : 'none',
      padding: '20px',
      marginBottom: '20px',
    };
    const sectionStyles = {
        display: layoutType === 'row' ? 'flex' : 'block',
    };
    // const sectionStyles = {
    //   display: isMobile ? 'flow-root' : (layoutType === 'row' ? 'flex' : 'block'),
    // };

    switch (block.block_type) {
      case '1':
        return (
          <div className="block-preview block-type-1" style={containerStyles}>
            <h2>{block.title}</h2>
            <div className="block-content" style={sectionStyles}>
              { block.image1 && (
                <img src={block.image1} alt="Custom" style={imgStyles} />
              )}
              <p dangerouslySetInnerHTML={{ __html: block.textarea1 || '' }} />
            </div>
          </div>
        );
      case '2':
        return (
          <div className="block-preview block-type-2" style={containerStyles}>
            <h2>{block.title}</h2>
            <div className="block-content" style={sectionStyles}>
                <p dangerouslySetInnerHTML={{ __html: block.textarea1 || '' }} />
                { block.image1 && (
                  <img src={block.image1} alt="Custom" style={imgStyles} />
                )}
            </div>
          </div>
        );
      case '3':
        return (
          <div className="block-preview block-type-3" style={containerStyles}>
            <h2>{block.title}</h2>
            <div className="block-content" style={sectionStyles}>
              { block.image1 && (
                <img src={block.image1} alt="Custom" style={imgStyles} />
              )}
              <p dangerouslySetInnerHTML={{ __html: block.textarea1 || '' }} />
              { block.image2 && (
                <img src={block.image2} alt="Custom" style={imgStyles2} />
              )}
            </div>
          </div>
        );
      case '4':
        return (
          <div className="block-preview block-type-4" style={containerStyles}>
            <h2>{block.title}</h2>
            <div className="block-content" style={sectionStyles}>
              { block.image1 && (
                <img src={block.image1} alt="Custom" style={imgStyles} />
              )}
              <p dangerouslySetInnerHTML={{ __html: block.textarea1 || '' }} />
              { block.image2 && (
                <img src={block.image2} alt="Custom" style={imgStyles2} />
              )}
              <p dangerouslySetInnerHTML={{ __html: block.textarea2 || '' }} />
            </div>
          </div>
        );
      default:
        return (
        <div className="block-preview block-type-1" style={containerStyles}>
            <h2>{block.title}</h2>
            <div className="block-content">
            { block.image1 && (
              <img src={block.image1} alt="Custom" style={imgStyles} />
            )}
            <p dangerouslySetInnerHTML={{ __html: block.textarea1 || '' }} />
            </div>
        </div>
        );
    }
  };

  return (
    <div className="dynamic-block-container">
      {Object.keys(blockData).map((blockKey, index) => (
        index + 1 === sectionNumber && (
          <div key={blockKey} className="block-container">
            {renderBlockContent(blockData[blockKey])}
          </div>
        )
      ))}
    </div>
  );
};

export default Section;


function renderSectionComponents() {
    const sections = document.querySelectorAll('section[id^="mm_dynamic_sections_block_"]');
    sections.forEach(section => {
        const config = section.getAttribute('data-config');
        if (config) {
        const parsedConfig = JSON.parse(config);
        const container = section.querySelector('.react-dynamic-block');
        if (container) {
            ReactDOM.render(
            <Section
                sectionNumber={parsedConfig.sectionNumber}
                apiUrl={parsedConfig.PY_API_URL}
                showBorder={parsedConfig.showBorder}
                borderColor={parsedConfig.borderColor}
                image1Width={parsedConfig.image1Width}
                image2Width={parsedConfig.image2Width}
                imageAlign={parsedConfig.imageAlign}
                layoutType={parsedConfig.layoutType}
                textContent={parsedConfig.textContent}
                category_code={parsedConfig.category_code}
            />,
            container
            );
        } else {
            console.error('Container element not found');
        }
        } else {
        console.error('Configuration not found');
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    renderSectionComponents();
});
